<template>
  <div class="drawer" style="height: calc(100vh - 60px);">
    <CommonSearch
      style="border-bottom:none"
      :search-label="searchLabel"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    >
    </CommonSearch>
    <div class="drawer-content">
      <div class="drawer-box"><DrawerSalary ref="DrawerSalary"></DrawerSalary></div>
    </div>
  </div>
</template>
<script>
import DrawerSalary from '../../DrawerSalary'
import { searchLabel2Value } from '../constant/utils'
import CommonSearch from '../searchBar/CommonSearch'

const searchLabel = '行业薪酬'
export default {
  components: { DrawerSalary, CommonSearch },
  data: function() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
    }
  },
  methods: {
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    goBack() {
      this.$emit('goBack')
    },
    defaultSearch({ type, keywords, result }) {
      try {
        app.service('misc').insertSearchHistory({ type: searchLabel, keywords: keywords })
      } catch (e) {}
      this.$refs.DrawerSalary.search(keywords)
    },
  },
}
</script>
<style scoped src="../constant/css/drawer.css"></style>
